import { isVisible } from './utils/utils';

export default function () {
    const dropdownPickers = document.querySelectorAll('.mainpage-dropdown');

    dropdownPickers.forEach(dp => {
        const allOptions = dp.querySelectorAll('label');
        const selectedButton = dp.querySelector('.mainpage-dropdown-button');

        const selectedLabelItem = dp.querySelector('input[type="radio"]:checked + label');
        const selectedSpanContent = selectedLabelItem ? selectedLabelItem.innerHTML : '---';
        selectedButton.innerHTML = selectedSpanContent;

        allOptions.forEach(option => {
            option.addEventListener('click', function () {
                selectedButton.innerHTML = this.innerHTML;
                dp.classList.remove('show-dropdown');
            });
        });

        selectedButton.addEventListener('click', function () {
            dp.classList.toggle('show-dropdown');
        });

        document.addEventListener('click', function (event) {

            if (!dp.contains(event.target) && isVisible(dp)) {
                dp.classList.remove('show-dropdown');
            }
        });
    });
}